import React from "react";

const ClientInformationConsentAgreement = ({ companyName = '', clientAddress = '', clientName = '' }) => {
  const lenderName = companyName || '______________________________';
  const residingAt = clientAddress || '______________________________';

  return (
    <div className="mt-8">
      <h2 className="font-bold text-base mb-4 uppercase">CLIENT INFORMATION CONSENT AGREEMENT</h2>
      <p className="text-sm mb-2">I, {clientName || '______________________________'}, residing at {residingAt}, hereby grant consent to {lenderName}, as follows:</p>
      <p className="text-sm mb-2">I authorise {lenderName} to collect, process, and store my personal information, including but not limited to my name, contact details, identification number, and banking details, to carry out its business functions, such as providing financial services, processing payments, and complying with legal obligations.</p>
      <p className="text-sm mb-2">I consent to {lenderName} sharing my personal information with third parties (e.g., banks, credit bureaus, or regulatory authorities) as necessary to perform its business functions, provided such sharing complies with applicable Namibian data protection laws.</p>
      <p className="text-sm mb-2">I understand that my personal information will be handled confidentially and securely under {lenderName}'s data protection policies and applicable regulations.</p>
      <p className="text-sm mb-2">This consent remains valid until revoked by me in writing, subject to any legal or contractual obligations that require continued processing.</p>
    </div>
  );
};

export default ClientInformationConsentAgreement;
